import { Injectable } from '@angular/core';
import { OrigamiResponse, ServiceBase } from './base/service.base';
import { Observable } from 'rxjs';
import { TopicServiceModel, TopicServiceOptions } from '@app/origami-api/models/topic-service.model';

// Created this service to get rid of Circular Dependency (SessionService -> TopicService -> TimeZoneService -> SessionService)
@Injectable()
export class TopicTypesService extends ServiceBase {
  serviceUrl = 'TopicService.svc';

  getTopicTypes(
    body: TopicServiceOptions.GetTopicTypes = {},
    ...params
  ): Observable<OrigamiResponse<TopicServiceModel.TopicType[]>> {
    return this.origamiPost('/GetTopicTypes', body, ...params);
  }
}
